import '/public/static/css/module/category.scss';
import MyPlusApi from '@/api/main/my-plus';
import {DEFAULT_POSTER_THUMB_TMG} from '@/constants/common/images';
import {SectionHeader} from '@/components/main/common';
import {convertViewCnt, isLogin} from '@/utils/main';
import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {sendClickLog} from '@/utils/main/my-plus/log';
import useGlobalUIStore from '@/stores';
import {CATEGORY_SLICE_CNT} from '@/constants/main';
import useMainStore from '@/stores/main';

export const CategoryList = ({selectedMode}) => {
  const {isDarkMode} = useGlobalUIStore();
  const {resizeCategoryCount} = useMainStore();

  const [categoryList, setCategoryList] = useState([]);
  const [displayedContent, setDisplayedContent] = useState([]);
  const [headerText, setHeaderText] = useState('인기 카테고리');

  const isPrefer = selectedMode === 'prefer' && isLogin();

  const handleImageError = (e) => {
    const imgElement = e.target;
    imgElement.src = DEFAULT_POSTER_THUMB_TMG(isDarkMode);
    imgElement.setAttribute('data-replaced', 'true');
  };

  const getPreferCategoryList = async () => {
    try {
      const param = {
        type: isPrefer ? selectedMode : 'popular',
      };
      const response = await MyPlusApi.getPreferCategoryList(param);
      if (response && response.data) {
        setCategoryList(response.data);
      }
    } catch (error) {
      setCategoryList([]);
    }
  };

  const handleClickCategory = (item, idx) => {
    const location = isPrefer ? 'myplus' : selectedMode;
    sendClickLog('cate_list', {
      buttonType: `${location}_cate`,
      location: location,
      filterId: item.categoryName,
      filterIdx: idx + 1,
    });
  };

  useEffect(() => {
    // 클라이언트에서만 실행
    if (isPrefer) {
      setHeaderText('선호 카테고리');
    }
  }, [selectedMode]);

  useEffect(() => {
    setDisplayedContent([...categoryList.slice(0, resizeCategoryCount)]);
  }, [categoryList, resizeCategoryCount]);

  useEffect(() => {
    getPreferCategoryList();
  }, []);

  return (
    <>
      {displayedContent && displayedContent.length > 0 && (
        <>
          <SectionHeader
            customElement={
              <>
                <h2>{headerText}</h2>
                <Link to={`/directory/category`} className='more'>
                  전체보기
                </Link>
              </>
            }
          />
          <div className='category_conts'>
            <ul>
              {displayedContent.map((item, idx) => (
                <li key={idx} onClick={() => handleClickCategory(item, idx)}>
                  <Link
                    to={`/directory/category/${encodeURIComponent(item.categoryName)}/live`}>
                    {item.viewCnt > 0 && (
                      <span className='views'>
                        <em>{convertViewCnt(item.viewCnt)}</em>
                      </span>
                    )}
                    <div className='thumb'>
                      <img
                        src={item.cateImg}
                        alt={item.categoryName}
                        onError={handleImageError}
                      />
                    </div>
                    <div className='info_wrap'>
                      <p className='title'>{item.categoryName}</p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};
